import apiLocal from "./api-local";
import apiProd from "./api-prod";

const hostname = typeof window !== "undefined" ? window.location.hostname : null;
const port = typeof window !== "undefined" ? window.location.port : null;
let isLocalApi = port >= 3000;
export const API = (hostname === 'localhost' && isLocalApi) ? apiLocal : apiProd
